import { render, staticRenderFns } from "./DashboardSelection.vue?vue&type=template&id=53157101&scoped=true"
import script from "./DashboardSelection.vue?vue&type=script&lang=js"
export * from "./DashboardSelection.vue?vue&type=script&lang=js"
import style0 from "./DashboardSelection.vue?vue&type=style&index=0&id=53157101&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53157101",
  null
  
)

export default component.exports